import {
  DefaultFetchError,
  FetchCreate, FetchDelete,
  FetchGet,
  FetchGetId,
  FetchSuccess,
  FetchUpdate,
  PagingDataResponse,
  PagingParams,
  useFetchCreate, useFetchDelete,
  useFetchGet,
  useFetchGetId, useFetchUpdate,
} from '../fetch';
import { Product } from './products';

export interface Article {
  id: string;
  createdAt: string;
  title: string;
  status: 'draft' | 'published';
  types: 'text' | 'video' | 'image' | 'file';
  content: string;
  tags: (string | null)[];
  files: (string | null)[];
  product: Product;
  category: Category;
  subCategory: SubCategory;
  views: string;
  removed: boolean;
  relatedArticles?: RelatedArticles[];
  isBookmarkedByCurrentUser?: boolean;
}

// /articles/{id}/helpful

export interface Helpful {
  id: string;
}
export interface Category {
  id: string;
  name: string;
}
export interface SubCategory {
  id: string;
  name: string;
}
export interface RelatedArticles {
  id: string;
  title: string;
}

export interface Meta {
  page: number;
  pageSize: number;
  itemCount: number;
  pageCount: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface ArticleResponse {
  data: Article[];
  meta: Meta;
}

export interface ArticleParams {
  pageSize?: string;
  status?: 'draft' | 'published';
  title?: string;
  page?: string;
  productId?: string;
  categoryId?: string[];
  subCategoryId?: string[];
  bookmarked?: boolean;
  orderBy?: 'ASC' | 'DESC';
  orderByColumn?: 'createdAt' | 'updatedAt' | 'title' | 'status' | 'type' | 'views' | 'helpful';
}
interface ArticleFetchOptions {
  autoStart?: boolean;
  params?: ArticleParams;
}

export const useArticlesGet = (
  options?: ArticleFetchOptions,
): FetchGet<ArticleResponse, ArticleParams, DefaultFetchError> => (
  useFetchGet('articles', { autoStart: options?.autoStart ?? true, authorization: true, params: options?.params })
);

export const useArticleTagsGet = (): FetchGet<string[], ArticleParams, DefaultFetchError> => (
  useFetchGet('articles/tags', { authorization: false })
);

export const useArticlesGetById = <DD = Article>(
  id?: string,
  decorateData?: (data: Article) => DD,
): FetchGetId<
  Article,
  DefaultFetchError,
  unknown,
  DD
> => useFetchGetId(
    'articles',
    id,
    {
      authorization: true,
      autoStart: !!id,
      decorateData,
    },
  );

export const useHelpful = (id?: string): FetchCreate<Partial<Helpful>, DefaultFetchError> => (
  useFetchCreate(`articles/${id}/helpful`, { autoStart: false })
);

export const useAddBookmark = (id?: string): FetchCreate<Partial<Helpful>, DefaultFetchError> => (
  useFetchCreate(`articles/${id}/addBookmark`, { autoStart: false })
);

export const useRemoveBookmark = (id?: string): FetchDelete<
  FetchSuccess, DefaultFetchError
> => (
  useFetchDelete(`articles/${id}/removeBookmark`)
);
